import { STANDARD_BAND } from "@/data/site";
import { Reveal } from "@/components/site/Reveal";
import Img from "@/components/site/Img";

export const Standard = () => (
  <section
    id="standard"
    data-testid="standard-section"
    className="relative bg-obsidian overflow-hidden"
  >
    {/* Photography sits to the right; the scrim keeps the statement legible. */}
    <div className="absolute inset-y-0 right-0 w-full md:w-3/5 overflow-hidden bg-onyx scrim-left">
      <Img
        src={STANDARD_BAND.src}
        alt={STANDARD_BAND.alt}
        className="w-full h-full object-cover object-[center_30%]"
      />
    </div>

    <div className="relative mx-auto max-w-shell px-6 md:px-10 py-20 md:py-28">
      <Reveal>
        <h2 className="font-display font-normal text-ivory leading-[1.08] tracking-[-0.015em] text-[clamp(1.75rem,4vw,3.25rem)] max-w-[16ch]">
          {STANDARD_BAND.title}
        </h2>

        <div className="mt-8 space-y-2">
          {STANDARD_BAND.lines.map((l) => (
            <p key={l} className="label text-ivory/70">
              {l}
            </p>
          ))}
          <p className="label text-champagne pt-1">{STANDARD_BAND.kicker}</p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Standard;
